import React from 'react'
import EdcLogo from '../assets/edcLogo.jpg'
// import FooterBg from '../assets/footer-bg.jpg'
import FooterBg from '../assets/footerimg.jpg'
import { useAuthStore } from '../store/authStore'
import { useNavigate } from 'react-router-dom'

const Footer: React.FC = () => {
  const { language, authenticated } = useAuthStore()
  const navigate = useNavigate()
  const handleGrievanceClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (authenticated) {
      navigate('/dashboard')
    } else {
      navigate('/login')
    }
  }
  return (
    <footer className="relative text-darkBlue ">
      {/* Background Image Layer */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${FooterBg})` }}
      ></div>

      {/* Gray Overlay Layer */}
      <div className="absolute inset-0 bg-gray-100 bg-opacity-80"></div>

      {/* Footer Content */}
      <div className="relative z-9 py-20 px-4 md:px-[65px] grid grid-cols-1 md:grid-cols-[1fr_1fr_2fr_1fr] gap-6">
        {/* Left Column */}
        <div className="w-full">
          <img
            src={EdcLogo}
            alt="KIED Logo"
            className="mb-4 h-14 mix-blend-multiply"
          />
          <p className="text-sm font-medium">
            Kerala Institute for Entrepreneurship Development <br />
            Rockwell Road, <br />
            HMT Colony PO, <br />
            Kalamassery, <br />
            Cochin - 683 503
          </p>
          <p className="text-sm mt-2 font-medium">
            Tel: 0484 2550322, <br /> 2532890. <br />
            Email:{' '}
            <a href="mailto:ceo.kied@gmail.com" className="underline">
              ceo.kied@gmail.com
            </a>
            <br />
            {/* <a
              href="https://www.kied.info"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              www.kied.info
            </a> */}
          </p>
        </div>

        {/* Center Column */}
        <div className="w-full">
          <h3 className="font-bold mb-4">
            {language === 'lang_mal' ? 'സഹായം & പിന്തുണ' : 'Help & Support'}
          </h3>
          <ul className="space-y-2 text-sm font-medium">
            <li>
              <a href="/about-us/contact" className="hover:underline">
                {language === 'lang_mal' ? 'സഹായം' : 'Help'}
              </a>
            </li>
            <li>
              <a
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {language === 'lang_mal'
                  ? 'നിബന്ധനകളും വ്യവസ്ഥകളും'
                  : 'Terms & Conditions'}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={handleGrievanceClick}
                className="hover:underline"
              >
                {language === 'lang_mal' ? 'പൊതു പരാതി' : 'Grievance Redressal'}
              </a>
            </li>
            <li>
              <a href="/about-us/contact" className="hover:underline">
                {language === 'lang_mal' ? 'ഞങ്ങളെ ബന്ധപ്പെടുക' : 'Contact Us'}
              </a>
            </li>
          </ul>
        </div>

        {/* Google Maps Column */}
        <div className="w-full shadow-[0px_3px_8px_rgba(0,0,0,0.24)]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.5465607375554!2d76.33020251146151!3d10.054225172056112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080c24f0be9eff%3A0x4255e36bd9bfad1e!2sKerala%20Institute%20for%20Entrepreneurship%20Development!5e0!3m2!1sen!2sin!4v1756356931257!5m2!1sen!2sin"
            width="100%"
            height="290"
            allowFullScreen
            loading="lazy"
            className=""
          />
        </div>

        {/* Right Column */}
        <div className="w-full ">
          <div>
            <h3 className="font-bold mb-4">
              {language === 'lang_mal'
                ? 'പിന്തുണയുള്ള പങ്കാളികൾ'
                : 'Supporting Partners'}
            </h3>
            <ul className="space-y-2 text-sm mb-4 font-medium">
              <li>
                {language === 'lang_mal'
                  ? 'വ്യവസായ & വാണിജ്യ വകുപ്പ്'
                  : 'Directorate of Industries and Commerce'}
              </li>
              <li>
                {language === 'lang_mal' ? 'എം.എസ്.എം.ഇ-ഡി.ഐ' : 'MSME-DI'}
              </li>
              <li>{language === 'lang_mal' ? 'എൻ.ഐ.എം.എസ്.എം.ഇ' : 'NIMSME'}</li>
              <li>{language === 'lang_mal' ? 'ഇ.ഡി.ഐ.ഐ' : 'EDII'}</li>
              <li>{language === 'lang_mal' ? 'ഐ.എൽ.ഒ' : 'ILO'}</li>
              <li>
                {language === 'lang_mal' ? 'ഐ.ഐ.ടി പാലക്കാട്' : 'IIT Palakkad'}
              </li>
              <li>{language === 'lang_mal' ? 'ഐ.ഐ.എം കോഴിക്കോട്' : 'IIMK'}</li>
              <li>
                {language === 'lang_mal'
                  ? 'കണ്ണൂർ സർവകലാശാല'
                  : 'Kannur University'}
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="relative z-10 text-center py-4 text-sm bg-darkBlue bg-opacity-50 text-white">
        {language === 'lang_mal'
          ? 'കോപിരൈറ്റ് © 2025 കേരളാ സംരംഭകത്വ വികസന ഇൻസ്റ്റിറ്റ്യൂട്ട്'
          : 'Copyright © 2025 Kerala Institute For Entrepreneurship Development'}
      </div>
    </footer>
  )
}

export default Footer
